/**
 * Eurus-style products-per-page: save cart attribute, reload collection/search section.
 * Every device starts at 60 (set in the section Liquid; 30, 60 or 120, so every row is full) until someone picks a
 * size.
 */
(function () {
  var ORIGIN_KEY = 'collection-pagination-origin';

  function cartUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/update.js';
  }

  function currentSearchParamsWithoutPage() {
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    return params.toString();
  }

  /* A new page size keeps the shopper where they are: once the grid comes back, the Show N menu sits at the
     same spot on screen it had before, instead of the page jumping to the top. */
  function keepMenuInPlace(select) {
    var before = select.getBoundingClientRect().top;
    window.riKeepScrollNextRender = true;
    document.addEventListener(
      'ri:grid-replaced',
      function () {
        /* The grid holds its old height through the swap; let it take its new height before measuring. */
        var host = document.getElementById('ProductGridContainer');
        if (host) host.style.minHeight = '';
        var moved = false;
        var stop = function () {
          moved = true;
        };
        window.addEventListener('wheel', stop, { passive: true, once: true });
        window.addEventListener('touchstart', stop, { passive: true, once: true });
        var align = function () {
          if (moved) return;
          var next = document.querySelector('[data-ri-per-page-select]');
          if (!next) return;
          var delta = next.getBoundingClientRect().top - before;
          if (Math.abs(delta) < 2) return;
          var y = (window.pageYOffset || document.documentElement.scrollTop || 0) + delta;
          window.scrollTo({ top: Math.max(0, y), behavior: 'instant' });
        };
        align();
        /* Again once the rows have been measured and evened out. */
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(align);
        });
        window.setTimeout(align, 700);
      },
      { once: true }
    );
  }

  function refreshSection(select) {
    var searchParams = currentSearchParamsWithoutPage();
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
      if (select) keepMenuInPlace(select);
      /* Bust section cache — page size lives in cart attribute, not the URL */
      FacetFiltersForm.filterData = [];
      FacetFiltersForm.renderPage(searchParams, null, true);
      return;
    }
    var url = window.location.pathname;
    if (searchParams) url += '?' + searchParams;
    window.location.assign(url);
  }

  function writeSize(value, origin) {
    var root = document.querySelector('[data-ri-per-page]');
    var attr = (root && root.getAttribute('data-ri-per-page-attr')) || 'collection-pagination';
    var body = { attributes: {} };
    body.attributes[attr] = value;
    body.attributes[ORIGIN_KEY] = origin;
    return fetch(cartUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
  }

  function onChange(evt) {
    var select = evt.target;
    if (!select || !select.matches('[data-ri-per-page-select]')) return;
    select.disabled = true;
    try {
      sessionStorage.removeItem('ri-ppp-lock');
    } catch (e) {}
    writeSize(select.value, 'choice')
      .then(function () {
        refreshSection(select);
      })
      .catch(function () {
        select.disabled = false;
      });
  }

  document.addEventListener('change', onChange);
})();
